/**
 * Index Page
 *
 * Author : vijay verma
 * Created : 04-Jan-2020
 */

import React from "react"
import { Link, graphql } from "gatsby"

import Hero from "../components/hero"
import Footer from "../components/footer"
import Projects from "../components/projects"
import Layout from "../components/layout"
import SEO from "../components/seo"

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="All posts" />
        <Hero />
        <Projects />
        <section className="tech-stack-section">
          <div className="container">
            <div className="tech-box">
            <h3>Our Tech Stack</h3>
            <a href="https://www.zomato.com/blog/category/technology" className="blog-link">
                <span className="btn-read">Read more about our tech</span>
                <ul>
                  <li><img src="/swift.png"/></li>
                  <li><img src="/android.png"/></li>
                  <li><img src="/nodejs.png"/></li>
                  <li><img src="/kotlin.png"/></li>
                  <li><img src="/php.png"/></li>
                  <li><img src="/rails.png"/></li>
                  <li><img src="/react.png"/></li>
                  <li><img src="/java.png"/></li>
                </ul>
              </a>
            </div>
          </div>
        </section>
        <section className="career-section">
          <div className="container">
            <div className="career-box">
                <h2>Be a part of our story</h2>
                <p>We're always looking for great folks to join us on our mission. If you want to be a part of our story, we'd love to chat.</p>
                <div className="btn-lnks">
                  <a href="https://www.zomato.com/careers" className="btn btn-fill">
                    Work with us
                  </a>
                </div>
            </div>
          </div>
        </section>
        <Footer />
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
